import LeaveFeedback from "../components/LeaveFeedback";
import FeaturedBy from "../components/Misc/FeaturedBy";
import Stats from "../components/Stats/Stats";
import { useAppContext } from "../_context";
import Hero from "../components/Pages/Clubs/Hero";
import Benefits from "../components/Pages/Clubs/Benefits";
import ImageLeftFooter from "../components/Footer/ImageLeftFooter";
import Button from "../components/Misc/Button";
import BlueBoxImageAndText from "../components/Misc/BlueBoxImageAndText";
import ExclusiveAccess from "../components/Pages/Clubs/ExclusiveAccess";
import WaitingList from "../components/Pages/Clubs/WaitingList";
import { useEffect, useState } from "react";
import Contentful from "../utilities/Contentful";
import { getPercent } from "../utilities/Helpers";
import Head from "next/head";

const Clubs = () => {
  const [{ tx, locale }] = useAppContext();
  const [stats, setStats] = useState([]);

  useEffect(() => {
    async function getStats() {
      const results = await new Contentful().fetchValueOnly({
        content_type: "statistics",
        "fields.slug[in]": "clubs,bookings-increase,membership-increase",
      });
      const intl = new Intl.NumberFormat(locale);

      setStats([
        {
          svg: "/img/stat/stat-2.svg",
          subheading: tx["stat:Clubs"],
          label:
            intl.format(results.find((x) => x.slug === "clubs").value) + "+",
        },
        {
          svg: "/img/stat/stat-bookings.svg",
          subheading: tx["Bookings Increase"],
          label: results.find((x) => x.slug === "bookings-increase").value,
        },
        {
          svg: "/img/stat/stat-membership.svg",
          subheading: tx["Memberships Increase"],
          label: results.find((x) => x.slug === "membership-increase").value,
        },
        {
          svg: "/img/stat/stat-engaged.svg",
          subheading: tx["Engaged clubs"],
          label: getPercent(100, locale),
        },
      ]);
    }
    getStats();
  }, []);

  return (
    <>
      <Head>
        <title>RacketPal - {tx["Clubs"]}</title>
      </Head>
      <Hero />
      <BlueBoxImageAndText image="/img/clubs/features.jpg">
        <h2>{tx["A digital hub for your club"]}</h2>
        <p className="text-grey-1">
          {
            tx[
              "As a racket sports venue, you can use RacketPal to help your members organise matches, track scores, set up leagues, play more and engage with a wider audience of players in your local area."
            ]
          }
        </p>
        <Button href="/clubs/signup">{tx["Register your club"]}</Button>
      </BlueBoxImageAndText>
      <Benefits />
      <Stats items={stats} />
      <FeaturedBy />
      <ExclusiveAccess />
      <WaitingList />
      <LeaveFeedback />
      <ImageLeftFooter image="/img/footers/signup.jpg">
        <h2>{tx["Let's get digital"]}</h2>
        <p>
          {
            tx[
              "Get the tools you need to make your club even more user-friendly"
            ]
          }
        </p>
        <Button href="/clubs/signup">{tx["Get started"]}</Button>
      </ImageLeftFooter>
    </>
  );
};

export default Clubs;
